import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const INK        = '#1a1a18';
const INK_MUTED  = '#6b6b63';
const PAPER      = '#f5f3ee';
const PAPER_CARD = '#faf9f6';
const BORDER     = '#ddd9d0';
const GREEN      = '#2d5a3d';

export default function LoginPage({ error: initialError }) {
  const [error, setError] = useState(initialError);

  return (
    <div style={{ minHeight: '100vh', background: PAPER, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', paddingTop: '15vh', paddingLeft: '16px', paddingRight: '16px' }}>
      <div style={{ background: PAPER_CARD, border: `1px solid ${BORDER}`, borderRadius: 10, padding: '48px 44px', maxWidth: 440, width: '100%', textAlign: 'center' }}>

        {/* Logo */}
        <div style={{ fontSize: 26, fontFamily: 'Georgia, serif', color: INK, marginBottom: 6, letterSpacing: '0.01em' }}>
          2nd<span style={{ color: GREEN }}>Counsel</span>
        </div>
        <div style={{ fontSize: 10, fontFamily: 'monospace', color: INK_MUTED, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 40 }}>
          Attorney Intelligence Platform
        </div>

        {/* Auth error */}
        {error && (
          <div style={{ background: '#fdf0f0', border: '1px solid #e8b8b8', borderRadius: 6, padding: '10px 14px', marginBottom: 20, fontSize: 13, fontFamily: 'sans-serif', color: '#8b2020', textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
            <span>{error}</span>
            <button onClick={() => setError('')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#8b2020', fontSize: 16, lineHeight: 1, padding: 0, flexShrink: 0 }}>×</button>
          </div>
        )}

        {/* CTA */}
        <button
          onClick={() => {
            console.log('[redirectAfterLogin] saving:', window.location.href);
            sessionStorage.setItem('redirectAfterLogin', window.location.href);
            window.location.href = `${API_URL}/auth/login`;
          }}
          style={{ width: '100%', padding: '13px 0', background: GREEN, color: '#fff', border: 'none', borderRadius: 6, fontSize: 15, fontFamily: 'sans-serif', fontWeight: 600, cursor: 'pointer', letterSpacing: '0.01em', marginBottom: 16 }}
        >
          Sign in with Microsoft 365
        </button>

        {/* Account type note */}
        <p style={{ fontSize: 12, color: INK_MUTED, fontFamily: 'sans-serif', marginBottom: 16, marginTop: -8 }}>
          You must be signed into a Microsoft 365 work or school account to continue. Personal Microsoft accounts are not supported.
        </p>

        {/* Fine print */}
        <p style={{ margin: 0, fontSize: 12, fontFamily: 'sans-serif', color: GREEN, lineHeight: 1.6 }}>
          <a href="mailto:support@2ndcounsel.com" style={{ color: GREEN, textDecoration: 'none' }}>
            Request access at support@2ndcounsel.com
          </a>
          {' '}if you don't have an account.
        </p>
      </div>
    </div>
  );
}
